import { USER_ROLE } from "../constants/index";
import { currentUserActions } from '../reducers/currentUser';
import isEqual from "lodash/isEqual";
import i18n from 'i18next';

export const getItemsByPage = (array: any, page: any, itemsPerPage: any) => {
  if(!array || array.length === 0) {
    return [];
  }
    // Tính toán vị trí bắt đầu và kết thúc
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    // Lấy các phần tử của trang hiện tại
    return array.slice(startIndex, endIndex);
};

export const getItemsYear = (yearInput : null | undefined | number, range:any = 100) => {
  const dataYear = [];
  let year = null;
  if (yearInput) {
    year = yearInput;
  } else {
    const dateNow = new Date();
    year = dateNow.getFullYear();
  }

  for (let i = year; i >= year - range; i--) {
    dataYear.push({ id: i, name: `${i}` });
  }
  return dataYear;
};

export const getItemsMonth = () => {
  const dataMonth = [];
  for (let i = 1; i <= 12; i++) {
      const id = String(i);
      dataMonth.push({ id: i, name: `${id}` });
  }
  return dataMonth;
};

export const getItemsDay = (year=2000, month=1) => {
  const daysInMonth = new Date(year, month, 0).getDate(); // Số ngày trong tháng
  const dates = [];

  for (let i = 1; i <= daysInMonth; i++) {
    const id = String(i);
    dates.push({ id: i, name: `${id}` });
  }

  return dates;
};

export function uniqueArray(arr: string[]) {
  const outputArray = Array.from(new Set(arr))
  return outputArray
}

export function handleErrorResponse(error: any, role: string, thunkAPI: any, message?: string) {
  const userRoles = [USER_ROLE.COMPANY, USER_ROLE.TALENT, USER_ROLE.CONTROL];

  if (error?.status === 403) {
    return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_ACCESS_DENIED'));
  }

  if (userRoles.includes(role) && error?.status === 401) {
    thunkAPI.dispatch(currentUserActions.setInitState());
    window.location.assign(window.location.href);
    throw new Error("Redirecting due to 401");
  }
  
  let msg = message;
  if (!msg) {
    const neutralizeHtml = (value: unknown) =>
       String(value ?? '').replace(/&/g, '＆').replace(/</g, '＜').replace(/>/g, '＞');
    if (error?.body && typeof error.body === 'object' && 'message' in error.body) {
      msg = neutralizeHtml((error.body as any).message);
    } else if (error?.body && typeof error.body === 'object' && 'detail' in error.body) {
      msg = neutralizeHtml((error.body as any).detail);
    } else if (error?.status === 413) {
      msg = i18n.t('MSG_TALENT_UPLOAD_MAX_FILE_SIZE');
    } else if (error?.message) {
      msg = neutralizeHtml(error.message);
    } else {
      msg = i18n.t('MSG_GLOBAL_INTERNAL_SERVER_ERROR');
    }
  }

  return thunkAPI.rejectWithValue(msg);
}

export function getMinPublicTime() {
  return new Date(new Date().getTime() + 60 * 60000); // 1 hour later
}

export const sortByCustomOrder = <T>(
  dataArray: T[],
  orderArray: string[],
  key: keyof T
): T[] => {
  return [...dataArray].sort((a, b) => {
    return orderArray.indexOf(a[key] as string) - orderArray.indexOf(b[key] as string);
  });
};

export function getIdFromObject(object: any) {
  if (!object) {
    return null;
  }
  return object?.id ? object?.id : null;
}

export function getListIdFromListObject(objects: any, delimiter = ",") {
  if (!objects) {
    return "";
  }
  return objects.map(item => item.id).join(delimiter);
}

export function getTabId(): string {
  declare global {
    interface Window {
      __TAB_ID__?: string;
    }
  }

  if (typeof window === "undefined") return "server";

  if (window.__TAB_ID__) return window.__TAB_ID__!;

  let id = window.name;
  if (!id) {
    const rnd =
      typeof crypto !== "undefined" && "randomUUID" in crypto
        ? crypto.randomUUID()
        : Math.random().toString(36).slice(2);
    window.name = rnd;
    id = rnd;
  }
  window.__TAB_ID__ = id;
  return id;
}

export function forceReload(responseID: any, currentUser: any) {
  if (!responseID)
    return;
  
  const currentUserID =
    currentUser.superUserInfo?.user_id ??
    currentUser.staffInfo?.user_id ??
    currentUser.talentInfo?.user_id ??
    null;

  if (currentUserID != responseID) {
    const channel = new BroadcastChannel("auth_channel");
    channel.postMessage({
      type: "forceReload",
      sender: getTabId(),
    });
    channel.close();
  }

  return;
}

export const getAgeNumberFromDate = (birthday: string | Date): string => {
    if (!birthday) {
        return '';
    }

    const birthdayObj = new Date(birthday);
    if (isNaN(birthdayObj.getTime())) {
        return '';
    }
    const today = new Date();
    let age = today.getFullYear() - birthdayObj.getFullYear();
    const monthDifference = today.getMonth() - birthdayObj.getMonth();

    // Check birthday
    if (
        monthDifference < 0 ||
        (monthDifference === 0 && today.getDate() < birthdayObj.getDate())
    ) {
        age--;
    }

    if (parseInt(age) <= 0) {
      return '';
    }

    return parseInt(age);
};

export const getDateFromAge = (age: number): string => {
  if (!age || age <= 0) {
    return '';
  }

  const today = new Date();
  const birthDate = new Date(
    today.getFullYear() - age,
    today.getMonth(),
    today.getDate()
  );

  return birthDate;
};

export const getRangeAge = (dateFrom: string | Date, dateTo: string | Date): string => {
  if (!dateFrom && !dateTo) return null;

  let ageFrom = '';
  let ageTo = '';

  if (!dateFrom) {
    ageFrom = getAgeNumberFromDate(dateTo);
  }
  else if (!dateTo) {
    ageTo = getAgeNumberFromDate(dateFrom);
  }
  else {    
    ageFrom = getAgeNumberFromDate(dateTo);
    ageTo = getAgeNumberFromDate(dateFrom);
  }

  return { ageFrom, ageTo }
}

export const getRangeDateOfBirth = (ageFrom: string | number, ageTo: string | number): string => {
  if (!ageFrom && !ageTo) return null;

  let dateFrom = '';
  let dateTo = '';

  if (!ageFrom) {
    dateFrom = getDateFromAge(ageTo);
  }
  else if (!ageTo) {
    dateTo = getDateFromAge(ageFrom);
  }
  else {    
    dateFrom = getDateFromAge(ageTo);
    dateTo = getDateFromAge(ageFrom);
  }

  return { dateFrom, dateTo }
}

export function updatePaginatedList({
  state,
  payload,
  listKey,
  selectedKey,
  currentPageKey,
  pageSizeKey,
  hasMoreKey
}) {
  if (state[currentPageKey] === 1) {
    state[listKey] = [];
  }

  state[selectedKey] = payload.results?.tags_selected;

  if (payload?.count === 0) {
    state[currentPageKey] = 1;
    state[listKey] = [];
  } else {
    const newItems = payload.results.data;
    const merged = [...state[listKey], ...newItems];
    const uniqueMap = new Map();

    merged.forEach(item => {
      uniqueMap.set(item.id, item);
    });

    state[listKey] = Array.from(uniqueMap.values());

    const countPageLoading = Math.ceil(payload.count / state[pageSizeKey]);

    state[hasMoreKey] = state[currentPageKey] < countPageLoading;
  }
}

let isDownloadAttachmentInProgress = false;

export const downloadFile = (url: string, filename?: string) => {
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename || "download");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadFileAttachment = async (url: string, filename?: string) => {
  if (isDownloadAttachmentInProgress) {
    return;
  }

  isDownloadAttachmentInProgress = true;
  try {
    // If it's already a blob or data URL, we use the traditional fallback
    if (url.startsWith('blob:') || url.startsWith('data:')) {
      const link = document.createElement('a');
      link.href = url;
      link.download = filename || 'download';
      document.body.appendChild(link);
      link.click();
      link.remove();
      return;
    }

    const res = await fetch(url);
    if (!res.ok) {
      throw new Error(i18n.t('MSG_GLOBAL_FILE_NOT_EXIST_OR_DELETED'));
    }

    const rawBlob = await res.blob();
    // Keep your original blob configuration
    const blob = new Blob([rawBlob], { type: 'application/octet-stream' });

    // --- CASE 1: Chrome / Edge / Chromium supporting showSaveFilePicker ---
    if ('showSaveFilePicker' in window) {
      try {
        const handle = await window.showSaveFilePicker({
          suggestedName: filename || 'download',
        });
        
        // Write the blob data directly to the user-selected OS path
        const writable = await handle.createWritable();
        await writable.write(blob);
        await writable.close();
        return; // Success, exit early!
        
      } catch (error: any) {
        // Handle "Cancel" case gracefully
        if (error.name === 'AbortError') {
          console.log('User cancelled the OS File Explorer dialog.');
          return; // Exit silently as requested by user action
        }
        
        // If it's any other type of error, log it and fall back to classic download
        console.warn('showSaveFilePicker failed, falling back to legacy download method:', error);
      }
    }

    // --- CASE 2: Fallback for Safari, Firefox, and Unsupported Browsers ---
    const objectUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = filename || 'download';

    document.body.appendChild(link);
    link.click();

    await new Promise((resolve) => setTimeout(resolve, 300));

    link.remove();
    window.URL.revokeObjectURL(objectUrl);
  } finally {
    isDownloadAttachmentInProgress = false;
  }
};

export const downloadQRCodeWithLogo = async (
  qrCanvas: HTMLCanvasElement | null,
  filename = "qr-with-logo.png"
) => {
  if (!qrCanvas) return;

  // Final export size: 240 × 240 px → ~15 mm at 400 DPI
  const exportSize = 240;

  // Create a new offscreen canvas for export
  const canvas = document.createElement("canvas");
  canvas.width = exportSize;
  canvas.height = exportSize;

  const ctx = canvas.getContext("2d");
  if (!ctx) return;

  // Keep sharp edges when scaling up
  ctx.imageSmoothingEnabled = false;

  // Draw the original QR (including logo)
  ctx.drawImage(qrCanvas, 0, 0, exportSize, exportSize);

  // Convert to PNG
  const url = canvas.toDataURL("image/png");

  downloadFile(url, filename);
};

export const handleCopy = (text: string, triggerMessage) => {
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text).then(() => triggerMessage()).catch((err) => {
      console.error("Clipboard write failed:", err);
    });
  } else {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      triggerMessage();
    } catch (err) {
      console.error("Fallback copy failed:", err);
    } finally {
      document.body.removeChild(textArea);
    }
  }
};

export function isEqualOnCommonFields(obj1, obj2) {
  const commonKeys = Object.keys(obj1).filter((key) =>
    Object.prototype.hasOwnProperty.call(obj2, key)
  );

  return commonKeys.every((key) => isEqual(obj1[key], obj2[key]));
};

export const getNameByObject = (object: any): string => {
  if (!object) {
    return null;
  }
  return object.name;
};

export const getObjectByName = (name: any, items: any) => {
  if (!name || items.length <= 1) {
    return null;
  }
  for(let item of items) {
    if(item.name == name) {
      return item
    }
  }
  return null;
};

export const getObjectById = (id: any, items: any) => {
  if (!id || items.length == 0) {
    return null;
  }
  for(let item of items) {
    if(item.id == id) {
      return item
    }
  }
  return null;
};

export const checkHasAdvanceFilledKeys = ( formData: Record<string, any>) => {
  const advanceKeys = [
    "email", "date_of_birth_start", "date_of_birth_end", "work_parttime", "job_view_level",
    "scout_history", "viewed_job_id", "scout_job_id", "register_code", "gender",
    "profession_2_id", "profession_3_id", "industry_1_id", "industry_2_id", "industry_3_id",
    "expected_condition", "preferred_city_id", "working_style_id", "is_referred",
    "referrer_talent", "department", "reason_resignation", "date_join_company_start",
    "date_leave_company_end", "job_view_level", "last_job_viewed_time", "viewed_job_obj",
    "viewed_new_obj", "scout_history", "scout_job_obj", "agent_info", 
    "ownership_period_start_date_start", "ownership_period_end_date_start", "withdrawn_talent_included"
  ];

  return advanceKeys.some(key => {
    const value = formData[key];

    const hasValue =
      value !== null &&
      value !== "" &&
      value !== undefined &&
      !(Array.isArray(value) && value.length === 0);
    
    return hasValue;
  });
}

export const getTimeErrorMessage = (dateError, hourError, minuteError, hourError2, minuteError2) => {
  if (dateError) {
    return dateError;
  }
  
  if (hourError === i18n.t('MSG_GLOBAL_HOUR_MINUTE_RANGE')) {
    return hourError;
  }
  if (minuteError === i18n.t('MSG_GLOBAL_HOUR_MINUTE_RANGE')) {
    return minuteError;
  }
  if (hourError2 === i18n.t('MSG_GLOBAL_HOUR_MINUTE_RANGE')) {
    return hourError2;
  }
  if (minuteError2 === i18n.t('MSG_GLOBAL_HOUR_MINUTE_RANGE')) {
    return minuteError2;
  }

  if (hourError) {
    return hourError;
  }
  if (minuteError) {
    return minuteError;
  }
  if (hourError2) {
    return hourError2;
  }
  if (minuteError2) {
    return minuteError2;
  }

  return null;
};

export const getStableFile = (file: File): Promise<File> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const arrayBuffer = reader.result as ArrayBuffer;
        const stableFile = new File([arrayBuffer], file.name, { type: file.type });
        resolve(stableFile);
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsArrayBuffer(file);
  });
};